import resetBorders from './resetBorders.module.scss';
import resetCorners from './resetCorners.module.scss';
import setCorners from './setCorners.module.scss';
export { default as ConnectedGroup } from './ConnectedGroup';
export const defaultStyles = {
    resetCorners,
    resetBorders,
    setCorners,
};
